var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"declare-guide"},[_c('div',{staticClass:"dec-tit"},[_vm._v("申报指南")]),_c('div',{staticClass:"dec-cont",domProps:{"innerHTML":_vm._s(_vm.dataHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }